import { createGlobalStyle } from "styled-components"

/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const Tokens = createGlobalStyle`

:root {

  // fonts
  --text-2xs:   10px;
  --text-xs:    0.75rem;
  --text-sm:    0.875rem;
  --text-md:    1rem;
  --text-lg:    1.25rem;
  --text-2xl:   1.75rem;
  --text-4xl:   2.625rem;

}
`
